(function () {
    'use strict';

  angular
    .module('checker.core')
    .config(config)
    .run(runApp);

    config.$inject = ['$httpProvider', '$provide'];

    function config($httpProvider, $provide) {
      $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache';
      // $provide.decorator('$q', function ($delegate) {
      //     // http://dorp.io/blog/extending-q-promises.html
      //   function decoratePromise(promise) {
      //     promise._then = promise.then;
      //     promise.then = function (thenFn, errFn, notifyFn) {
      //         var p = promise._then(thenFn, errFn, notifyFn);
      //         return decoratePromise(p);
      //     };

      //     promise.error = promise["catch"];
      //     promise["catch"] = function () {
      //         throw "Do not use catch as it's not supported by IE8, use error instead";
      //     };


      //     promise.always = promise["finally"];
      //     promise["finally"] = function () {
      //         throw "Do not use finally as it's not supported by IE8, use always instead";
      //     };


      //     return promise;
      //   }

      //   var defer = $delegate.defer,
      //       when = $delegate.when,
      //       reject = $delegate.reject,
      //       all = $delegate.all;
      //   $delegate.defer = function () {
      //       var deferred = defer();
      //       decoratePromise(deferred.promise);
      //       return deferred;
      //   };
      //   $delegate.when = function () {
      //       var p = when.apply(this, arguments);
      //       return decoratePromise(p);
      //   };
      //   $delegate.reject = function () {
      //       var p = reject.apply(this, arguments);
      //       return decoratePromise(p);
      //   };
      //   $delegate.all = function () {
      //       var p = all.apply(this, arguments);
      //       return decoratePromise(p);
      //   };

      //   return $delegate;
      // });
    }

    function runApp() {
      // CacheFactory("version", { storageMode: 'localStorage', maxAge: 24 * 60 * 60 * 1000, deleteOnExpire: "aggressive" });
      // CacheFactory("HIVDrugs", { storageMode: 'localStorage', maxAge: 24 * 60 * 60 * 1000, deleteOnExpire: "aggressive" });
      // CacheFactory("HIVCoMeds", { storageMode: 'localStorage', maxAge: 24 * 60 * 60 * 1000, deleteOnExpire: "aggressive" });
      // CacheFactory("HIVInteractions", { storageMode: 'localStorage', maxAge: 24 * 60 * 60 * 1000, deleteOnExpire: "aggressive" });
    }

})();
